import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

const BrokerageCalculator = () => {
  const navigate = useNavigate();

  // State for dynamic inputs
  const [propertyValue, setPropertyValue] = useState(5000000);
  const [commissionPct, setCommissionPct] = useState(2);

  // Dynamic calculations
  const brokerageAmount = (propertyValue * commissionPct) / 100;
  const finalSellerAmount = propertyValue - brokerageAmount;

  // Chart.js Data Configuration
  const chartData = {
    labels: ['Take-home Pay', 'Brokerage Fee'],
    datasets: [
      {
        data: [finalSellerAmount, brokerageAmount],
        backgroundColor: ['#10b981', '#f43f5e'], // Emerald and Rose
        hoverBackgroundColor: ['#059669', '#e11d48'],
        borderWidth: 0,
      },
    ],
  };

  const chartOptions = {
    plugins: {
      legend: {
        position: 'bottom',
      },
    },
    cutout: '70%', // Makes it a clean donut shape
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div className="container py-4">
      <div className="d-flex align-items-center mb-4">
        <button className="btn btn-light rounded-circle me-3 shadow-sm" onClick={() => navigate('/calculators')}>
          ←
        </button>
        <h4 className="fw-bold mb-0">Brokerage Calculator</h4>
      </div>

      <div className="row g-4">
        {/* Left Side: Inputs */}
        <div className="col-lg-6">
          <div className="bg-white rounded-4 shadow-sm border p-4 h-100">
            <h5 className="mb-4 fw-bold text-secondary">Adjust Details</h5>
            
            <div className="mb-5">
              <div className="d-flex justify-content-between mb-2">
                <label className="text-muted">Property Value (₹)</label>
                <span className="fw-bold text-primary">₹{propertyValue.toLocaleString('en-IN')}</span>
              </div>
              <input 
                type="range" className="form-range" 
                min="100000" max="100000000" step="100000"
                value={propertyValue}
                onChange={(e) => setPropertyValue(Number(e.target.value))}
              />
              <input 
                type="number" className="form-control mt-2" 
                value={propertyValue}
                onChange={(e) => setPropertyValue(Number(e.target.value))}
              />
            </div>

            <div className="mb-4">
              <div className="d-flex justify-content-between mb-2">
                <label className="text-muted">Commission Rate (%)</label>
                <span className="fw-bold text-primary">{commissionPct}%</span>
              </div>
              <input 
                type="range" className="form-range" 
                min="0.5" max="10" step="0.5"
                value={commissionPct}
                onChange={(e) => setCommissionPct(Number(e.target.value))}
              />
            </div>
          </div>
        </div>

        {/* Right Side: Chart & Results */}
        <div className="col-lg-6">
          <div className="bg-white rounded-4 shadow-sm border p-4 h-100 text-center">
            <h5 className="mb-4 fw-bold text-secondary">Summary Breakdown</h5>
            
            <div style={{ position: 'relative', height: '250px', width: '100%' }}>
              <Doughnut data={chartData} options={chartOptions} />
            </div>

            <div className="mt-4 pt-3 border-top">
              <div className="row text-start">
                <div className="col-6">
                  <p className="small text-muted mb-0">Total Brokerage</p>
                  <h4 className="text-danger fw-bold">₹{brokerageAmount.toLocaleString('en-IN')}</h4>
                </div>
                <div className="col-6">
                  <p className="small text-muted mb-0">Final Amount</p>
                  <h4 className="text-success fw-bold">₹{finalSellerAmount.toLocaleString('en-IN')}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrokerageCalculator;